export const dict = {
    TotalProfit: "Total Profit:",
    TotalStake: "Total Stake:",
    LoadMore: "Show More Bets",
    NoData: "No data",
    TotalReturn: "Total Return",
    Stake: "Stake:",
    BetPlacement: "Placed",
    BetId: "BET ID",
    MarketResult: "Results",
    Starts: "Starts",
    EachWay: "EW",
    EachWayStakeInfo: "({0} bets X {1})",
    Open: "OPEN",
    Lost: "LOST",
    Won: "WON",
    Placed: "PLACED",
    WonDeadHeat: "WON DEAD HEAT",
    PlacedDeadHeat: "PLACED DEAD HEAT",
    Draw: "DRAW",
    Cancelled: "CANCELLED",
    NonRunner: "NON RUNNER",
    HalfLost: "HALF LOST",
    HalfWon: "HALF WON",
    CashOut: "CASHOUT",
    SelectionStatusOpen: "O",
    SelectionStatusLost: "L",
    SelectionStatusWon: "W",
    SelectionStatusPlaced: "P",
    SelectionStatusWonDeadHeat: "WDH",
    SelectionStatusPlacedDeadHeat: "PDH",
    SelectionStatusDraw: "D",
    SelectionStatusCancelled: "C",
    SelectionStatusNonRunner: "NR",
    SelectionStatusHalfLost: "HL",
    SelectionStatusHalfWon: "HW",
    SelectionStatusCashOut: "CO",
    FreeBetMessage: "Free Bet Contribution: {0}",
    RiskFreeBetMessage: "Risk free bet Contribution: {0}",
    ComboBonusMessage: "Includes {0} ({1}%) Combo Boost winnings",
    TurnoverTax: "{1}% tax on stake ({0})",
    NetWinningsTax: "{1}% tax on winnings ({0})",
    FullReturnTax: "{1}% tax on return ({0})",
    ErrorMessage: "Whoops! Something went wrong, please try again later.",
    ViewAll: "View All",
    ViewLess: "View Less",
    ViewBetDetails: "View Bet Details",
    HideBetDetails: "Hide Bet Details",
    Last24Hours: "Last 24 Hours",
    Last48Hours: "Last 48 Hours",
    LastWeek: "Last Week",
    LastMonth: "Last Month",
    Last3Months: "Last 3 Months",
    Last6Months: "Last 6 Months",
    Last12Months: "Last 12 Months",
    ComboNames_2: "Doubles",
    ComboNames_3: "Trebles",
    ComboNames_4: "4-folds",
    ComboNames_5: "5-folds",
    ComboNames_6: "6-folds",
    ComboNames_7: "7-folds",
    ComboNames_8: "8-folds",
    ComboNames_9: "9-folds",
    ComboNames_10: "10-folds",
    ComboNames_11: "11-folds",
    ComboNames_12: "12-folds",
    ComboNames_13: "13-folds",
    ComboNames_14: "14-folds",
    ComboNames_15: "15-folds",
    ComboNames_16: "16-folds",
    ComboNames_17: "17-folds",
    ComboNames_18: "18-folds",
    ComboNames_19: "19-folds",
    ComboNames_20: "20-folds",
    BettingHistoryTabLabel: "Betting History",
    Trixie: "Trixie",
    Yankee: "Yankee",
    SuperYankee: "Super Yankee",
    Heinz: "Heinz",
    SuperHeinz: "Super Heinz",
    Goliath: "Goliath",
    Patent: "Patent",
    Lucky15: "Lucky 15",
    Lucky31: "Lucky 31",
    Lucky63: "Lucky 63",
    System2from3: "System 2 from 3",
    System2from4: "system 2 from 4",
    System2from5: "System 2 from 5",
    SystemStakeDetails: "({0} bets x {1})",
    YourBet: "YourBet",
    PulseBet: "PulseBet ({0})",
    NotAvailable: "N/A",
    DeadHeatRule: "Dead Heat applied.",
    Rule4Deduction: "Rule 4 Deduction applied.",
    StraightForecast: "Straight Forecast",
    ReversedForecast: "Reversed Forecast",
    StraightTricast: "Straight Tricast",
    CombinationForecast: "Combination Forecast",
    CombinationTricast: "Combination Tricast",
    CastPosition1: "1st",
    CastPosition2: "2nd",
    CastPosition3: "3rd",
    Teaser2Teams6Points: "Teaser 2 Teams 6 Points",
    Teaser2Teams6_5Points: "Teaser 2 Teams 6.5 Points",
    Teaser2Teams7Points: "Teaser 2 Teams 7 Points",
    Teaser3Teams6Points: "Teaser 3 Teams 6 Points",
    Teaser3Teams6_5Points: "Teaser 3 Teams 6.5 Points",
    Teaser3Teams7Points: "Teaser 3 Teams 7 Points",
    SuperTeaser3Teams10Points: "Super Teaser 3 Teams 10 Points",
    Teaser4Teams6Points: "Teaser 4 Teams 6 Points",
    Teaser4Teams6_5Points: "Teaser 4 Teams 6.5 Points",
    Teaser4Teams7Points: "Teaser 4 Teams 7 Points",
    MonsterTeaser4Teams13Points: "Monster Teaser 4 Teams 13 Points",
    Teaser5Teams6Points: "Teaser 5 Teams 6 Points",
    Teaser5Teams6_5Points: "Teaser 5 Teams 6.5 Points",
    Teaser5Teams7Points: "Teaser 5 Teams 7 Points",
    Teaser6Teams6Points: "Teaser 6 Teams 6 Points",
    Teaser6Teams6_5Points: "Teaser 6 Teams 6.5 Points",
    Teaser6Teams7Points: "Teaser 6 Teams 7 Points",
    Teaser2Teams4Points: "Teaser 2 Teams 4 Points",
    Teaser2Teams4_5Points: "Teaser 2 Teams 4.5 Points",
    Teaser2Teams5Points: "Teaser 2 Teams 5 Points",
    Teaser3Teams4Points: "Teaser 3 Teams 4 Points",
    Teaser3Teams4_5Points: "Teaser 3 Teams 4.5 Points",
    Teaser3Teams5Points: "Teaser 3 Teams 5 Points",
    SuperTeaser3Teams8Points: "Super Teaser 3 Teams 8 Points",
    Teaser4Teams4Points: "Teaser 4 Teams 4 Points",
    Teaser4Teams4_5Points: "Teaser 4 Teams 4.5 Points",
    Teaser4Teams5Points: "Teaser 4 Teams 5 Points",
    MonsterTeaser4Teams10Points: "Monster Teaser 4 Teams 10 Points",
    Teaser5Teams4Points: "Teaser 5 Teams 4 Points",
    Teaser5Teams4_5Points: "Teaser 5 Teams 4.5 Points",
    Teaser5Teams5Points: "Teaser 5 Teams 5 Points",
    Teaser6Teams4Points: "Teaser 6 Teams 4 Points",
    Teaser6Teams4_5Points: "Teaser 6 Teams 4.5 Points",
    Teaser6Teams5Points: "Teaser 6 Teams 5 Points"
};
//# sourceMappingURL=dict.js.map